import logo from "../../images/contactlogo.png"


export default function ContactLogo() {
  return (
    <img className="b-logo" src={logo} alt="contact logo" />
   
  );
}